<script setup lang="ts">
const perksFetch = usePerks()

const { pending, data: perks } = await useAsyncData('perks', async () => perksFetch.fetch())
</script>

<template>
  <CareersSection
    v-if="perks && !pending"
    :title="$t('careers.perks.title')"
    :eyebrow="$t('careers.perks.eyebrow')"
    :intro="$t('careers.perks.intro')"
    section-id="perks-section"
    class="xs:px-0 z-10 px-2"
  >
    <div class="xs:grid-cols-2 grid gap-4 sm:gap-8 lg:grid-cols-3 xl:grid-cols-4">
      <CareersPerk
        v-for="item of perks"
        :key="item.title"
        :title="item.title"
        :description="item.description"
        :icon="item.icon.url"
      />
    </div>
  </CareersSection>
</template>
